import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getGroupsByIds } from '../../../selectors/groups';
import {
  getProfileOwnerUser,
  getProfileOwnerStat,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';

import { GROUPS_MEMBER_IDS_STREAM } from '../../../streams';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';

export const groupsContainerCreator = streamId =>
  connect(
    (state: AppState) => {
      const type = streamId === GROUPS_MEMBER_IDS_STREAM ? 'member' : 'admin';
      const statName =
        streamId === GROUPS_MEMBER_IDS_STREAM ? 'groupsMember' : 'groupsAdmin';
      const totalCount = getProfileOwnerStat(state, statName);

      const groups = getGroupsByIds(
        state,
        streamSelectors.getItems(state, streamId)
      );

      const hasMore = streamSelectors.hasMore(state, streamId);
      const isFetching = streamSelectors.isFetching(state, streamId);

      return {
        type,
        profileOwnerUser: getProfileOwnerUser(state),
        isOwner: isCurrentUserProfileOwner(state),
        groups,
        isEmpty: !groups.length,
        hasMore,
        isFetching,
        totalCount,
        seeAllUrl: '#',
      };
    },
    dispatch => ({
      fetchMore: () => dispatch(withOffset.actions.fetch(streamId)),
    })
  );
